var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.tabs),function(tab,i){return _c('ClassicTabButton',{key:i,attrs:{"tab-position":i,"tab":tab}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }